import axios from 'axios'
import {serialize} from '../../../core/_util'

const API_URL = process.env.REACT_APP_BASE_API_URL
const GET_SHAREHOLDERS_OVERVIEW = `${API_URL}/captable-management/overview`
const GET_SHAREHOLDERS = `${API_URL}/stakeholders/shareholders`
const CREATE_SHAREHOLDER_INVESTMENT = `${API_URL}/captable-management/add-shareholder-investment`
const GET_SHAREHOLDER_INVESTMENT = `${API_URL}/captable-management/shareholders/investments`
const GET_SCENARIO = `${API_URL}/captable-management/scenario`
const UPDATE_SCENARIO_STATUS = `${API_URL}/captable-management/status`
const UPDATE_SCENARIO = `${API_URL}/captable-management/update`
const DELETE_SHAREHOLDER_INVESTMENT = `${API_URL}/captable-management/shareholders/new-investment`
const GET_TIMELINE = `${API_URL}/captable-management/timelines`
const GET_SLIDER = `${API_URL}/captable-management/slider`
const GET_CAPTABLE = `${API_URL}/captable-management/captable`
const GET_CAPTABLE_DATA = `${API_URL}/captable-management/authorized/captable`
const UPDATE_CAPTABLE = `${API_URL}/captable-management/authorized/update/captable`

export const getShareholders = (companyId: number, all?: boolean) => {
  return axios.get(
    `${GET_SHAREHOLDERS}?${all ? `&all=${all}` : ''}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getShareholder = (companyId: number, shareholderId: string) => {
  return axios.get(
    `${GET_SHAREHOLDERS}/${shareholderId}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getShareholderOverview = (companyId: number) => {
  return axios.get(`${GET_SHAREHOLDERS_OVERVIEW}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createShareholderInvestment = (payload: any, companyId: number) => {
  return axios.post(`${CREATE_SHAREHOLDER_INVESTMENT}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getAllShareholderInvestments = (companyId: number, payload: any) => {
  return axios.post(`${GET_SHAREHOLDER_INVESTMENT}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createScenario = (payload: any, companyId: number) => {
  return axios.post(`${GET_SCENARIO}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getAllScenario = (companyId: number, search: string) => {
  const queryParams = {
    search,
  }
  return axios.get(
    `${GET_SCENARIO}?${serialize(queryParams)}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const updateScenarioStatus = (companyId: number, payload: any) => {
  return axios.post(
    `${UPDATE_SCENARIO_STATUS}
    `,
    payload,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getScenario = (companyId: number, scenarioId: string) => {
  return axios.get(
    `${GET_SCENARIO}/${scenarioId}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}
export const updateScenario = (companyId: number, payload: any, scenarioId: string) => {
  return axios.post(
    `${UPDATE_SCENARIO}/${scenarioId}
    `,
    payload,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteScenario = (companyId: number, scenarioId: string) => {
  return axios.delete(
    `${GET_SCENARIO}/${scenarioId}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteInvestment = (companyId: number, investmentId: string) => {
  return axios.delete(
    `${DELETE_SHAREHOLDER_INVESTMENT}/${investmentId}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getAllTimeline = (companyId: number) => {
  return axios.get(
    `${GET_TIMELINE}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getSliderData = (companyId: number) => {
  return axios.get(
    `${GET_SLIDER}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getCaptable = (companyId: number, payload: any, search: string) => {
  const queryParams = {
    search,
  }

  return axios.post(
    `${GET_CAPTABLE}?${serialize(queryParams)}
    `,
    payload,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const exportCaptable = (companyId: number, payload: any) => {
  return axios.post(`${GET_CAPTABLE}/csv/export`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}
export const getCaptableData = (companyId: number) => {
  return axios.get(
    `${GET_CAPTABLE_DATA}
    `,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const updateCaptable = (companyId: number, payload: any) => {
  return axios.post(
    `${UPDATE_CAPTABLE}
    `,
    payload,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}
